<template>
  <div class="container">
    <el-card shadow="never">
      <el-form-item label="交易通知地址" prop="notifyAddress">
        <el-input class="form-input" v-model="form.notifyAddress" :disabled="passed || notPassed" placeholder="若不填，默认为代理商交易通知地址"></el-input>
      </el-form-item>
      <el-form-item label="审核回调地址" prop="auditCallback">
        <el-input class="form-input" v-model="form.auditCallback" :disabled="passed || notPassed" placeholder="若不填，默认为代理商审核回调地址"></el-input>
      </el-form-item>
    </el-card>
  </div>
</template>

<script>
import { agentMixins } from './agentMixins'
export default {
  mixins: [agentMixins],
  data () {
    return {
      rule_data: {
        notifyAddress: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }],
        auditCallback: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }]
      }
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .form-input {
      width: 450px;
  }
</style>
